module.exports = __webpack_public_path__ + "static/media/anymeets_placeholder_wide.3af78f73.svg";